module.exports = "https://cdn.hellotech.com/client-assets/featured-in-mobile_53e6a34899e133427d5c00e25dda5bd3.png";